<template>
  <el-dialog
    custom-class="SafeLock"
    :visible.sync="isVisible"
    :before-close="handleClose"
    width="400px"
    append-to-body
  >
    <div slot="title" class="title">
      <img :src="isLocked ? require('./resource/lock.svg') : require('./resource/unlock.svg')" />
      <span>
        {{ isLocked ? '解除安全锁' : '设置安全锁' }}
      </span>
    </div>
    <div v-show="isShowCodeCard">
      <p class="label">向您{{ mobile | obscured }}的手机发送短信验证码</p>
      <div class="codeBox">
        <el-input
          v-model="code"
          size="small"
          :minlength="6"
          :maxlength="6"
          placeholder="输入短信验证码"
          @blur="codeBlur"
          @input="codeValidator"
        />
        <span class="countDown" v-if="isShowCountDown" key="2"> {{ countDown }}s </span>
        <span class="sendCode" key="1" v-else @click="handleGetRecode">
          {{ isCodeHadSend ? '重新' : '' }}获取验证码
        </span>
      </div>
      <p class="tip">{{ codeTip }}</p>
    </div>
    <div v-show="!isShowCodeCard">
      <p class="label">全屏直播学习让孩子更专注</p>
      <el-input
        ref="passwordRef"
        class="password"
        v-model="password"
        type="password"
        size="small"
        placeholder="输入安全锁密码"
        :minlength="4"
        :maxlength="20"
        autocomplete="new-password"
        show-password
        @blur="passwordBlur"
        @input="passwordValidator"
      />
      <p class="tip">{{ passwordTip }}</p>
    </div>
    <div slot="footer" class="footer">
      <el-button
        class="forget"
        size="small"
        type="text"
        :style="{
          visibility: isLocked && !isShowCodeCard ? 'visible' : 'hidden',
        }"
        @click="isShowCodeCard = true"
      >
        忘记密码
      </el-button>
      <div class="btns">
        <el-button size="small" @click="handleCancel">
          {{ isShowCodeCard ? '返回' : '取消' }}
        </el-button>
        <el-button
          size="small"
          type="primary"
          :disabled="confirmButtonDisabled"
          @click="handleConfirm"
        >
          {{ isLocked ? '解锁' : '上锁' }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import TJCaptcha from '@/utils/TJCaptcha';
const maxTimeCount = 60; //倒计时开始数字
export default {
  name: 'SafeLock',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mobile: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isVisible: this.visible,
      isLocked: false,
      isShowCodeCard: false,
      isPasswordHadBlur: false,
      password: '',
      passwordTip: '',
      isCodeHadBlur: false,
      code: '',
      codeTip: '',
      isCodeHadSend: false,
      countDown: maxTimeCount,
      countDownTimer: null,
    };
  },

  computed: {
    confirmButtonDisabled() {
      return this.isShowCodeCard
        ? !this.isCodeHadSend || !!this.codeTip || !/^\d{6}$/.test(this.code.trim())
        : !!this.passwordTip || !/^\d{4,20}$/.test(this.password.trim());
    },
    isShowCountDown() {
      return this.countDown > 0 && this.countDown < maxTimeCount;
    },
  },

  filters: {
    obscured: function (value, beginIndex = 3, endIndex = 6) {
      if (!value) return '';
      value = value.toString();
      return value
        .split('')
        .map((char, index) => (index >= beginIndex && index <= endIndex ? '*' : char))
        .join('');
    },
  },

  watch: {
    visible: function (newVal) {
      this.isVisible = newVal;

      if (newVal === true) {
        this.reset();
        this.$nextTick(() => this.$refs['passwordRef'].focus());
      } else {
        this.$emit('update:visible', false);
      }
    },
  },

  async created() {
    if (this.$store.state.desktop) {
      this.isLocked = await this.$store.state.desktop.kiosk.isKiosk();
    }
  },

  mounted() {},

  beforeDestroy() {
    clearInterval(this.countDownTimer);
    this.reset();
  },

  methods: {
    passwordBlur() {
      this.isPasswordHadBlur = true;
      this.passwordValidator();
    },
    passwordValidator() {
      if (this.isPasswordHadBlur) {
        this.passwordTip = /^\d{4,20}$/.test(this.password) ? '' : '请输入4～20位数字密码';
      }
    },

    codeBlur() {
      this.isCodeHadBlur = true;
      this.codeValidator();
    },
    codeValidator() {
      if (this.isCodeHadBlur) {
        this.codeTip = /^\d{6}$/.test(this.code) ? '' : '请输入6位数字验证码';
      }
    },

    handleGetRecode() {
      this.isCodeHadBlur = false;
      this.code = '';
      this.codeTip = '';
      this.isCodeHadSend = true;
      this.getCode();

      //60秒倒计时
      this.countDown = maxTimeCount - 1;
      const initTime = Date.now(); //开始时间
      this.countDownTimer = setInterval(() => {
        const now = Date.now(); // 每次执行时重新获取当前时间，解决因页面切换后台后定时器执行被挂起，页面恢复激活时计数正确跳过暂停期间耽搁的计数
        if (now - initTime > maxTimeCount * 1000) {
          this.countDown = 0;
          clearInterval(this.countDownTimer);
        } else {
          this.countDown = maxTimeCount - Math.floor((now - initTime) / 1000);
        }
      }, 1000);
    },

    async getCode() {
      const ret = await TJCaptcha({ store: this.$store, message: this.$message });
      const data = await this.$http.post('/api/app/v1/smsCode', {
        mobile: this.mobile,
        sms_type: 'lockWindow',
        ticket: ret.ticket,
        randstr: ret.randstr,
      });

      console.log(`验证码发送: ${data ? '成功' : '失败'}`, data);
    },

    async reset() {
      this.isLocked = await this.$store.state.desktop.kiosk.isKiosk();
      this.isShowCodeCard = false;
      this.isPasswordHadBlur = false;
      this.password = '';
      this.passwordTip = '';
      this.isCodeHadBlur = false;
      this.code = '';
      this.codeTip = '';
      this.isCodeHadSend = false;
      this.countDown = maxTimeCount;
    },

    close() {
      this.$emit('update:visible', false);
      clearInterval(this.countDownTimer);
      this.reset();
    },

    handleClose(done) {
      done();
      this.close();
    },

    handleCancel() {
      if (this.isShowCodeCard) {
        this.isShowCodeCard = false;
      } else {
        this.close();
      }
    },

    async handleConfirm() {
      if (this.isLocked) {
        if (this.isShowCodeCard) {
          // const { result: isPass } = await this.$http.post(
          const data = await this.$http.post(
            '/api/app/unlock-window',
            {
              mobile: this.mobile,
              sms_code: this.code,
            },
            {
              onError: (data) => {
                if (
                  data.code === 201 &&
                  ['验证码错误，请重新输入', '验证码已过期，请重新获取!'].includes(data.msg)
                ) {
                  this.code = '';
                  this.codeTip = data.msg.split('，')[0];
                } else {
                  this.code = '';
                  this.codeTip = data.msg;
                }
              },
            },
          );

          // data为[]代表成功
          if (Array.isArray(data) && data.length === 0) {
            await this.$store.state.desktop.kiosk.setKiosk(false);
            await this.$store.state.desktop.kiosk.clearPassword();

            this.$message({
              message: '解锁成功',
              type: 'success',
            });
            this.close();
          }
        } else {
          const kioskPassword = await this.$store.state.desktop.kiosk.getPassword(); //窗口kiosk模式解锁密码
          if (kioskPassword === this.password) {
            await this.$store.state.desktop.kiosk.setKiosk(false);
            await this.$store.state.desktop.kiosk.clearPassword();

            this.$message({
              message: '解锁成功',
              type: 'success',
            });
            this.close();
          } else {
            this.passwordTip = '密码错误，请重新输入';
            this.isPasswordHadBlur = false;
            this.password = '';
          }
        }
      } else {
        await this.$store.state.desktop.kiosk.setKiosk(true);
        await this.$store.state.desktop.kiosk.setPassword(this.password);

        this.$message({
          message: '上锁成功',
          type: 'success',
        });
        this.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/varibles.scss';
::v-deep {
  .el-dialog__header {
    padding: 16px 24px;
    border-bottom: 1px solid var(--Gray-Gray3-, #e7e7e7);
    .title {
      display: flex;
      align-items: center;
      span {
        color: var(
          --text-icon-font-gy-190-primary,
          var(--text-icon-font-gy-190-primary, rgba(0, 0, 0, 0.9))
        );
        font-size: 16px;
        font-weight: 600;
        line-height: 24px; /* 150% */
      }
      img {
        margin-right: 16px;
      }
    }
    .el-dialog__headerbtn {
      top: 18px;
    }
  }
  .el-dialog__body {
    max-height: unset;
    padding: 24px;
    .label {
      color: var(
        --text-icon-font-gy-190-primary,
        var(--text-icon-font-gy-190-primary, rgba(0, 0, 0, 0.9))
      );

      /* Body/Medium */
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px; /* 157.143% */
      margin-bottom: 10px;
    }
    .el-input__inner[type='password'] + .el-input__suffix {
      .el-input__icon {
        display: flex;
        align-items: center;
        &::before {
          display: block;
          content: '';
          position: relative;
          right: -6px;
          width: 16px;
          height: 16px;
          background-image: url(./resource/closedEye.svg);
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
    .codeBox {
      position: relative;
      .sendCode,
      .countDown {
        position: absolute;
        top: 5px;
        right: 8px;
        text-align: right;

        /* Body/Medium */
        font-size: 14px;
        line-height: 22px; /* 157.143% */
      }
      .sendCode {
        color: #0f6bff;
        cursor: pointer;
      }
      .countDown {
        color: #666;
      }
    }
    .tip {
      margin-top: 10px;
      color: #f4242e;

      /* Body/Small */
      font-family: 'PingFang SC';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
      &:empty {
        height: 20px;
      }
    }
  }
  .el-dialog__footer {
    padding: 12px 24px;
    border-top: 1px solid var(--Gray-Gray3-, #e7e7e7);
    .footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .forget {
        color: var(--Coral-Brand, #0f6bff);
      }
      .el-button {
        border-radius: 6px;
      }
      .el-button--default {
        color: var(
          --text-icon-font-gy-190-primary,
          var(--text-icon-font-gy-190-primary, rgba(0, 0, 0, 0.9))
        );
      }
      .is-disabled {
        color: var(--text-icon-font-wh-190-anti, rgba(255, 255, 255, 0.9)) !important;
        opacity: 0.2;
        background: #f4242e !important;
      }
    }
  }
}
.SafeLock {
}
</style>
